<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称" :help="null">
              <global-select
                v-decorator="['planName', { rules: [{ required: true }] }]"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planType: 102 }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划版本" :help="null">
              <global-select
                v-decorator="['planVersion', { rules: [{ required: true }] }]"
                selectType="selectAssemble"
                :focusGet="true"
                requestApi="/scp/scpMrpPlans/planVersionBox"
                :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne', thirdLabelText: '最新版本' }"
                :setParams="{ dataType: 2, planType: 102, planName: form.getFieldsValue().planName }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <global-select
                v-decorator="['organizationCodeList']"
                selectType="selectMultiple"
                requestApi="/scp/scpMrpPlans/planOrganizationBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planType: 102, planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料类别">
              <a-tree-select
                :dropdown-style="{
                  maxHeight: '50vh'
                }"
                v-decorator="['categoryIdList']"
                :tree-data="treeData"
                :max-tag-count="1"
                :replaceFields="{children: 'child', title: 'name', key: 'segment', value: 'id' }"
                tree-checkable
                allow-clear
                tree-node-filter-prop="title"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料编码">
              <global-select
                v-decorator="['itemIdList']"
                selectType="selectMultipleSearch"
                :dropdown-match-select-width="false"
                requestApi="/scp/scpMrpSystemItems/planItemsBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="label"
                sourseField="res"
                :totalNum="9999999999"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="备料分类">
              <global-select
                v-decorator="['deliveryType']"
                selectType="select"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'MDM_DELIVERY_TYPE' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="库存状态">
              <global-select
                v-decorator="['onhandStatus']"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_MRP_KITTING_STATUS' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="DOI天数≤">
              <a-input-number v-decorator="['daysOfInventory']" :min="1" :precision="0" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="显示">
              <global-select
                v-decorator="['lineTypeList']"
                selectType="selectMultiple"
                :selectData="lineTypeListData"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24" class="aj-center-between">
            <a-form-item label="快捷过滤">
              <a-button v-for="item in searchList1" :key="item.id" type="link" @click="handleMenuClick(item)">{{ item.schemeName }}</a-button>
              <a-dropdown v-if="searchList2.length > 0">
                <a-menu slot="overlay">
                  <a-menu-item v-for="item in searchList2" :key="item.id" @click="handleMenuClick(item)">{{ item.schemeName }}</a-menu-item>
                </a-menu>
                <a-button type="link">更多<a-icon type="down" /> </a-button>
              </a-dropdown>
              <a-button @click="$refs.dressingByScreening.show(form.getFieldsValue())">保存筛选方案</a-button>
            </a-form-item>
            <span class="table-page-search-submitButtons">
              <a-button @click="$refs.dressingByScreeningSetUp.show()">设置筛选方案</a-button>
              <a-button @click="onSearch" type="primary" class="ml8">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-form layout="inline" :labelCol="{ style: { width: '120px' } }">
          <a-row class="align-center">
            <a-button type="primary" @click="handleExport" v-hasPermi="['scp:scpMrpShortageSummary:export']">导出</a-button>
            <a-col :md="7" :sm="24" class="ml20">
              <a-form-item label="数据收集时间">
                <a-input v-model="dataCollectStartDate" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24">
              <a-form-item label="叫料计算完成时间">
                <a-input v-model="planCompletionDate" disabled />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="serialNumber"
          :scroll="{ x: tableX, fixScreen: true }"
          @successCallBack="successCallBack"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation' && record.boss">
                <a @click="goNextPage(record)">分供应商明细</a>
              </span>
              <span v-if="item.dataIndex === 'otherBtn' && record.boss">
                <a @click="$refs.otherSupply.show(record)">查看明细</a>
              </span>
              <span v-else-if="(record.boss || columnsAdd.includes(item.dataIndex)) && Number(text) < 0" :class="['color-red', {'line-ellipsis':item.ellipsis}]" :title="item.ellipsis ? text : ''">{{ text }}</span>
              <span v-else-if="(record.boss || columnsAdd.includes(item.dataIndex))" :class="{ 'line-ellipsis': item.ellipsis }" :title="item.ellipsis ? text : ''">{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
        <dressing-by-screening-set-up ref="dressingByScreeningSetUp" @handle-success="handleOk" />
        <dressing-by-screening ref="dressingByScreening" @handle-success="handleOk2" />
        <OtherSupply ref="otherSupply" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiScpMrpShortageSummaryList,
  apiScpMrpCategoryCodeCategoryBox,
  apiScpScreeningSchemeSearchAllScheme,
  apiScpMrpPlansCallMaterialPlanExecutionTime,
  apiScpMrpShortageDatesDateDisplayList,
  apiScpMrpPlansPlanVersionBox
} from '@/api/scp/factoryCallMaterial/defaultMaterialGather'
import DressingByScreening from '@/components/DressingByScreening/index'
import DressingByScreeningSetUp from '@/components/DressingByScreeningSetUp/index'
import OtherSupply from './components/OtherSupply'
import { generateLsTableResData } from '@/utils/util.js';
export default {
  name: 'DefaultMaterialGather',
  components: {
    DressingByScreening,
    DressingByScreeningSetUp,
    OtherSupply
  },
  data () {
    return {
      isEdit: false,
      currentId: "",
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpShortageSummaryList, true),
        pageCurrent: true
      },
      // 查询参数
      form: this.$form.createForm(this),
      // 控制搜索展开
      advanced: true,
      // 表格数据
      tableX: 2500,
      tableList: [],
      // 表格字段
      columnsOrigin: [],
      columnsAdd: [],
      columns: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          scopedSlots: { customRender: 'itemCode' },
          align: 'center',
          width: 120,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'uom',
          scopedSlots: { customRender: 'uom' },
          align: 'center',
          width: 100,
          fixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          scopedSlots: { customRender: 'itemName' },
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          scopedSlots: { customRender: 'specification' },
          align: 'center',
          ellipsis: true,
          width: 200
        },
        {
          title: '一级分类',
          dataIndex: 'name1',
          scopedSlots: { customRender: 'name1' },
          align: 'center',
          ellipsis: true,
          width: 120
        },
        {
          title: '二级分类',
          dataIndex: 'name2',
          scopedSlots: { customRender: 'name2' },
          align: 'center',
          ellipsis: true,
          width: 120
        },
        {
          title: '三级分类',
          dataIndex: 'name3',
          scopedSlots: { customRender: 'name3' },
          align: 'center',
          ellipsis: true,
          width: 120
        },
        {
          title: '集采类型',
          dataIndex: 'centralizedPurchasingTypeName',
          scopedSlots: { customRender: 'centralizedPurchasingTypeName' },
          align: 'center',
          width: 120
        },
        {
          title: '备料分类',
          dataIndex: 'deliveryTypeName',
          scopedSlots: { customRender: 'deliveryTypeName' },
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '总需求',
          dataIndex: 'totalDemand',
          scopedSlots: { customRender: 'totalDemand' },
          align: 'center',
          width: 100
        },
        {
          title: '加工商库存',
          dataIndex: 'onhandQty',
          scopedSlots: { customRender: 'onhandQty' },
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: 'VMI已发',
          dataIndex: 'vmiShippedQty',
          scopedSlots: { customRender: 'vmiShippedQty' },
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '工厂总叫料',
          dataIndex: 'calledQty',
          scopedSlots: { customRender: 'calledQty' },
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '待叫料',
          dataIndex: 'toBeCalled',
          scopedSlots: { customRender: 'toBeCalled' },
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: 'VMI库存',
          dataIndex: 'vmiOnhandQty',
          scopedSlots: { customRender: 'vmiOnhandQty' },
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '当前DOI',
          dataIndex: 'daysOfInventory',
          scopedSlots: { customRender: 'daysOfInventory' },
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '库存状态',
          dataIndex: 'onhandStatusName',
          scopedSlots: { customRender: 'onhandStatusName' },
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: 'VMI缺料量',
          dataIndex: 'vmiShortage',
          scopedSlots: { customRender: 'vmiShortage' },
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '供应商在途',
          dataIndex: 'supplierInTransit',
          scopedSlots: { customRender: 'supplierInTransit' },
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '已确认',
          dataIndex: 'supplierCommitted',
          scopedSlots: { customRender: 'supplierCommitted' },
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '待确认',
          dataIndex: 'supplierToBeConfirmed',
          scopedSlots: { customRender: 'supplierToBeConfirmed' },
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '其他供应',
          dataIndex: 'otherBtn',
          scopedSlots: { customRender: 'otherBtn' },
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '项目',
          dataIndex: 'lineTypeName',
          scopedSlots: { customRender: 'lineTypeName' },
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '计划名称',
          dataIndex: 'planName',
          scopedSlots: { customRender: 'planName' },
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '计划版本',
          dataIndex: 'planVersion',
          scopedSlots: { customRender: 'planVersion' },
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '操作',
          width: 110,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      lineTypeListData: [], // 显示
      searchList1: [],
      searchList2: [],
      treeData: [], // 物料类别
      dataCollectStartDate: "", // 数据收集时间
      planCompletionDate: "" // 叫料计算完成时间
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  created () {
    this.columnsOrigin = JSON.parse(JSON.stringify(this.columns))
    this.getLookupList('SCP_MRP_LINE_TYPE_SHORT_TOTAL', 'lineTypeListData')
    this.getCategoryIdList(true)
    this.getSearchAllScheme()
  },
  mounted () {},
  methods: {
    // 跳转供应商
    goNextPage (record) {
      this.$router.push({ name: "DefaultMaterialSubSupplier", query: { data: JSON.stringify(record) } })
    },
    // 新增/修改框事件
    handleOk () {
      this.getCategoryIdList()
    },
    handleOk2 () {
      this.getCategoryIdList()
    },
    // 表单搜索
    onSearch () {
      if (!this.form.getFieldsValue().planName) {
        this.$message.warning('计划名称不能为空')
        return;
      }
      if (!this.form.getFieldsValue().planVersion) {
        this.$message.warning('计划版本不能为空')
        return;
      }
      this.isEdit = false
      this.getTableTime()
      this.lineTypeListChange(this.form.getFieldsValue().lineTypeList)

      const params = this.form.getFieldsValue()
      params.dataType = "WIP_SUMMARY"
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    successCallBack (myDataSource) {
      const arr = JSON.parse(JSON.stringify(myDataSource))
      const arr2 = arr.map(item => item.id)
      const arr3 = Array.from(new Set(arr2))
      const arr4 = []
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < arr3.length; j++) {
          if (arr[i].id === arr3[j] && !arr4.includes(arr3[j])) {
            arr4.push(arr3[j])
            arr[i].boss = true
          }
        }
      }
      this.$refs.dataTable.myDataSource = arr
    },
    // 快捷过滤
    handleMenuClick (val) {
      this.form.setFieldsValue(JSON.parse(val.schemeDetailJson))
      this.getPlanVersion()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.tableList = []
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      const params = this.form.getFieldsValue()
      params.dataType = "WIP_SUMMARY"
      this.download('scp/scpMrpShortageSummary/export', {
        ...params
      }, `工单欠料汇总报表_${new Date().getTime()}.xlsx`)
    },
    // 物料类别-下拉框数据
    getSearchAllScheme () {
      apiScpMrpCategoryCodeCategoryBox({ parameterCode: "SCP_ITEM_CATEGORY", parameterLevelCode: "GLOBAL" }).then(res => {
        if (res.data && res.data.length > 0) {
          this.treeData = res.data
        }
      })
    },
    // 计划版本字段-自动填充
    getPlanVersion () {
      apiScpMrpPlansPlanVersionBox({ dataType: 2, planType: 102, planName: this.form.getFieldsValue().planName }).then(res => {
        this.form.setFieldsValue({
          planVersion: ""
        })
        if (res.rows && res.rows.length > 0) {
          res.rows.forEach(element => {
            if (element.bringOutDataOne === "Y") {
              this.form.setFieldsValue({
                planVersion: element.realValue
              })
            }
          });
        }
        this.onSearch()
      })
    },
    // 快捷过滤数据
    getCategoryIdList (flag) {
      apiScpScreeningSchemeSearchAllScheme({ menuId: this.$route.meta.menuId }).then(res => {
        if (res.data && res.data.length > 0) {
          const arr = []
          const arr2 = []

          res.data.forEach((element, index) => {
            if (index < 3) {
              arr.push(element)
            } else {
              arr2.push(element)
            }
            if (flag && element.defaultFlag === "Y") {
              this.form.setFieldsValue(JSON.parse(element.schemeDetailJson))
              this.getPlanVersion()
            }
          });
          this.searchList1 = arr
          this.searchList2 = arr2
        } else {
          this.searchList1 = []
          this.searchList2 = []
        }
      })
    },
    getTableTime () {
      // 数据收集时间、叫料计算完成时间
      const params = this.form.getFieldsValue()
      params.dataType = "WIP_SUMMARY"
      apiScpMrpPlansCallMaterialPlanExecutionTime(params).then(res => {
        if (res.data) {
          this.dataCollectStartDate = this.$moment(res.data.dataCollectStartDate).format('YYYY-MM-DD HH:mm:ss')
          this.planCompletionDate = this.$moment(res.data.planCompletionDate).format('YYYY-MM-DD HH:mm:ss')
        }
      })
      // 动态表头
      apiScpMrpShortageDatesDateDisplayList({ planVersion: this.form.getFieldsValue().planVersion, dataType: "WIP_SUMMARY" }).then(res => {
        if (res.data && res.data.length > 0) {
          const columns = JSON.parse(JSON.stringify(this.columnsOrigin))
          const arr = res.data
          const arr2 = ['lineTypeName']
          arr.forEach((element, index) => {
            const obj = {
              title: element,
              dataIndex: `date${index + 1}`,
              scopedSlots: { customRender: `date${index + 1}` },
              align: 'center',
              width: 90
            }
            arr2.push(`date${index + 1}`)
            columns.splice(-3, 0, obj);
          });
          this.columnsAdd = arr2 || []
          this.columns = columns
          this.tableX = 2500 + res.data.length * 100
        } else {
          this.columns = JSON.parse(JSON.stringify(this.columnsOrigin))
        }
      })
    },
    // 动态修改页码
    lineTypeListChange (val) {
      if (!val || val.length === 0) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 20
        return
      }
      if (val.length === 1 || val.length === 5) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["10", "20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 10
      }
      if (val.length === 2 || val.length === 4) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["8", "20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 8
      }
      if (val.length === 3) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["9", "20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 9
      }
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (type === "SCP_MRP_LINE_TYPE_SHORT_TOTAL") {
          const arr2 = []
          response.rows.forEach(element => {
            if (element.attribute2 === "Y") {
              arr2.push(element.lookupCode)
            }
          });
          this.form.setFieldsValue({
            lineTypeList: arr2
          })
        }
        this[arr] = response.rows
      })
    }
  }
}
</script>

<style scoped lang="less">
.plan-time{
  font-weight: bold;
}
/deep/.ant-select-selection__choice{
  width: 66.47px;
}
/deep/.ant-input-number{
  width: 100%;
}
.color-red {
  color: red
}
</style>
